export * from './automation.service';
import { AutomationService } from './automation.service';
export * from './chat.service';
import { ChatService } from './chat.service';
export * from './communes.service';
import { CommunesService } from './communes.service';
export * from './company.service';
import { CompanyService } from './company.service';
export * from './document.service';
import { DocumentService } from './document.service';
export * from './faultReport.service';
import { FaultReportService } from './faultReport.service';
export * from './incident.service';
import { IncidentService } from './incident.service';
export * from './luxdata.service';
import { LuxdataService } from './luxdata.service';
export * from './maintenance.service';
import { MaintenanceService } from './maintenance.service';
export * from './messages.service';
import { MessagesService } from './messages.service';
export * from './orderfeedback.service';
import { OrderfeedbackService } from './orderfeedback.service';
export * from './orders.service';
import { OrdersService } from './orders.service';
export * from './private.service';
import { PrivateService } from './private.service';
export * from './stateHistory.service';
import { StateHistoryService } from './stateHistory.service';
export * from './userMapping.service';
import { UserMappingService } from './userMapping.service';
export const APIS = [AutomationService, ChatService, CommunesService, CompanyService, DocumentService, FaultReportService, IncidentService, LuxdataService, MaintenanceService, MessagesService, OrderfeedbackService, OrdersService, PrivateService, StateHistoryService, UserMappingService];
